module.exports = __webpack_public_path__ + "img/product-preview-32.92f0f97.png";